import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1687771093729'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='8390'
    >
        <path
            d='M945.724 511.931c0 83.503-178.842 261.637-433.701 261.637-248.372 0-433.701-175.202-433.701-261.637 0-86.422 186.128-261.356 433.701-261.356 256.862 0.001 433.762 174.935 433.701 261.357zM512.405 298.299c-115.427 0-208.998 95.714-208.998 213.774 0 118.061 93.57 213.774 208.998 213.774 115.462 0 209.036-95.714 209.036-213.774-0.001-118.06-93.574-213.774-209.036-213.774zM512.023 375.594c-73.507 0-133.097 60.94-133.097 136.122 0 75.173 59.59 136.125 133.097 136.125s133.073-60.952 133.073-136.125c0-75.182-59.566-136.122-133.073-136.122z'
            fill='currentColor'
            p-id='8391'
        ></path>
    </svg>
)

export const EyesOpenIcon = props => <Icon component={SVG} {...props} />
